import React, { useState } from "react";
import { connect } from "react-redux";
import shortid from "shortid";
import CompetitorBox from "../../VendorProfile/ProfileVerified/CompetitorBoxNew";
import SponsoredBox from "../../VendorProfile/ProfileVerified/SponsoredBoxNew";
import VendorProfileDetail from "../../VendorProfile/Common/VendorProfileDetail";
import VendorTestimonialLocked from "./VendorTestimonialLocked";
import VendorTestimonialUnlocked from "../TestimonialPremium/TestimonialBox";
import UpgradeProfilePopUp from "../../../Common/Popups/UpgradeProfile";
import { withRouter } from "react-router-dom";
import ClaimProfile from "../../../Common/Popups/ClaimProfile";

const VendorTestimonialSectionTop = props => {
  const [isUpgrade, setUpgrade] = useState(false);

  const getTwoReviews = reviews => {
    const tempTwoReviews = [...reviews];
    return tempTwoReviews.splice(0, 3);
  };
  const setClaimProfilePopUpFalse = () => {
    setUpgrade(false);
  };

  return (
    <React.Fragment>
      <ul>
        {!!props.vendorTestimonials.reviews &&
          props.vendorTestimonials.reviews.length > 0 &&
          getTwoReviews(props.vendorTestimonials.reviews).map(
            (review, index) => {
              if (
                props.vendorTestimonials.num_unblurred_reviews === -1 ||
                (props.paginationOn === 1 &&
                  index < props.vendorTestimonials.num_unblurred_reviews)
              ) {
                return (
                  <VendorTestimonialUnlocked
                    key={shortid.generate()}
                    {...review}
                    classToAdd
                    linkedInUrl={props.vendorTestimonials.linkedin_signin_url}
                    unblurredReviews={
                      props.vendorTestimonials.num_unblurred_reviews
                    }
                    isLeadGenPopUp={props.vendorProfile.is_lead_generate_popup}
                    pathname={props.location.pathname}
                  />
                );
              } else {
                return (
                  <VendorTestimonialLocked
                    {...review}
                    key={shortid.generate()}
                    vendor={props.vendorCommon.name}
                    reviewCount={props.vendorTestimonials.total_reviews_count}
                    setUpgrade={setUpgrade}
                    addClass={true}
                    unblurredReviews={
                      props.vendorTestimonials.num_unblurred_reviews
                    }
                    isFirstRow={true}
                    isLeadGenPopUp={props.vendorProfile.is_lead_generate_popup}
                    pathname={props.location.pathname}
                    linkedInUrl={props.vendorTestimonials.linkedin_signin_url}
                    vendorProfile={props.vendorProfile}
                  />
                );
              }
            }
          )}
      </ul>
      {isUpgrade && !props.vendorProfile.visitor ? (
        <ClaimProfile setClaimProfilePopUpFalse={setClaimProfilePopUpFalse} />
      ) : (
        false
      )}
    </React.Fragment>
  );
};

const mapStateToProps = state => {
  return {
    vendorCommon: state.vendorCommon,
    vendorTestimonials: state.vendorTestimonials,
  };
};

export default connect(mapStateToProps)(
  withRouter(VendorTestimonialSectionTop)
);
